import React, { useState } from 'react';
import './styles.scss';
import Logo from '../../assets/images/horizontal.png';
import LoginForm from './Form/LoginForm';
import charcaters from '../../assets/images/dummy&friend.png';
import { Trans } from 'react-i18next';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

function Login({ withCode, empty, extrernal, setIsUserLogged }) {

  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const cleint = localStorage.getItem('cleint');
  const navigate = useNavigate();
  const { jeton } = useParams();

  const upperCaseUrel = window.location.href.toUpperCase();
  const connexionUrl = upperCaseUrel.includes('LOGIN') || upperCaseUrel.includes('TESTINTERNE') || upperCaseUrel.includes('TESTINTERN');
  const connexionUrlExterne = jeton && window.location.href.includes(jeton);

  useEffect(() => {
    if (cleint && (connexionUrl || connexionUrlExterne)) {
      setIsUserLogged(false);
      localStorage.clear();
      connexionUrl ? navigate('/testInterne') : navigate('/');
      window.location.reload();
    }

    const AccessWithToken = () => {
      setIsLoginLoading(true);
      !cleint && axios.post(`${process.env.REACT_APP_DOMAIN_API}:${process.env.REACT_APP_DOCKER_API_PORT}/api/user_acces_token`, {
          jeton: jeton
      })
      .then ((response) => {
        if (response.status === 200) {
          setIsUserLogged(true);
          navigate('/');
          localStorage.setItem('user', response.data.firstName);
          localStorage.setItem('userid', response.data.id);
          localStorage.setItem('cleint', response.data.cleint);
          localStorage.setItem('credentials', response.data.token);
          localStorage.setItem('mode', 'jeton');
          toast.success('Bienvenue !');
          // TODO?! : keep for 2Auth \\
          // localStorage.setItem('phone', response.data.contact.sms);
          // localStorage.setItem('cleint', response.data.cleint);
          // localStorage.setItem('mode', 'jeton');

        }
      })
      .catch ((err) => {
        setIsUserLogged(false);
        navigate('/');
          if (err.status === 401) {
              throw new Error(`${err.data} ${err.status}`);
            } else if (err.status === 404) {
              throw new Error(`${err.data} ${err.status}`);
            } else if (err.status === 500) {
              throw new Error(`${err.data} ${err.status}`);
          }
          toast.error('Erreur de connexion');
      })
      .finally(() => {
        setIsLoginLoading(false);
      })
    }
    
    if (jeton) {
        AccessWithToken();
    }
  }
  , [jeton, navigate]);
  
  return (
    <div className={!isLoginLoading ? "Login" : "Login-loading"}>
      {isLoginLoading && (
        <div className="Login-loader" />
      )}
      <div className="Login-side--left">
        <h1 className="Login-side--left_title">
            <img className="Login-side--left_logo" src={Logo} alt="logo supplay" />
        </h1>
      </div>
      <div className="Login-side--right">
        {!empty && (
          <LoginForm withCode={withCode} setIsLoginLoading={setIsLoginLoading} external={extrernal} setIsUserLogged={setIsUserLogged} />
        )}
        {empty && (
          <div className="LoginForm">
            <div className="LoginForm-images">
                <img className="LoginForm-image" src={charcaters} alt="Copine de Dummy et Dummy" />
            </div>
              <h2 className="LoginForm-welcome" style={{textAlign: 'center'}}>
                  <Trans>Login.Welcome</Trans> !
              </h2>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
